import React, {Component} from 'react';
import { Pagination, Row, Col } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import StockStore from '../../stores/StockStore';
import StockEditProductModal from './StockEditProductModal';
import StockProductTransactionModal from './StockProductTransactionModal';
import ReportMobileTable from '../report/ReportMobileTable'
import {connect} from 'react-redux'
class StockOutOfStockReport extends Component {

  constructor(props){
    super(props)

    this.state = { 
      loading: false,
      data: [],
      dataDd: [],
      productImages:[],
      length: 10,
      totalPage: 0,
      activePage: 1,
      showStockPopup: false,
      showStockProductTransactionPopup: false,
      stockProductTitle: "",
      formDisplay: "",
      formDisplay2: "",
      formDisplayCost: "",
      dataSet: [],
      formValid: "",
      validState: "",
      setData: [],
      transaction_record:[]
    }
  }

  loadData(){
    this.loadOutOfStockList()
    this.loadCategory()    
  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  loadCategory() {
    let that = this

    StockStore.loadCategory(this.props.tool,function(result) {
      
      that.setState({dataDd: result.data})
    })
  }

  loadOutOfStockList(page = 1) { 
    this.setState({loading: true})

    if (page === 1) {
      var start = 0
      this.setState({ activePage: page })
    } else {
      var start = (page * 10) - 10
    }

    let {setData} = this.state
    setData['type'] = this.props.tool
    setData['start'] = start

    this.props.onLoadData(setData)

    // ReportStore.loadOutOfStockList(this.props.tool, start, this.state.length, function(result) {
      
    //   const totalPage = result.total_count / 10
    //   that.setState({loading: false, data: result.data, totalPage: Math.ceil(totalPage)})
    // })
  }

  handleSelect(e) { 

    this.setState({ activePage: e })
    this.loadOutOfStockList(e)
  }

  loadStockTransactionRecord(item) {
    let that = this

    StockStore.loadStockTransactionRecord(this.props.tool, item.itemnum, function(result) {
      let data = result.data
      data.push({added_date:item.added_date,record_type:'init',request_by:item.added_by,quantity:that.props.messages['No Data']})
      that.setState({transaction_record: data})
    })
  }

  onStockProductTransactionOpenClick(item, e) {

    if (item.itemnum > 0) {
      let that = this
      StockStore.loadImages(this.props.tool, item.itemnum, function (result) {
        that.setState({ productImages: result.data.files })
      })
    }

    let dataSet = {}
    dataSet = JSON.parse(JSON.stringify(item))
    dataSet = Object.assign({cat_id:dataSet.category},dataSet)
    dataSet['last_serial_id'] = ""
    dataSet['part_type'] = ""

    if(this.props.tool==='part' && this.props.searchType==='brand')
      dataSet['car_cat_id'] = this.props.catId

    this.setState({
      showStockProductTransactionPopup: true,
      description: item.description,
      added_date: item.added_date,
      added_by: item.added_by,
      quantity: item.quantity,
      unit: item.unit,
      remark: item.remark,
      productcode: item.productcode,
      last_serial_id: item.last_serial_id,
      itemnum: item.itemnum,
      cat_id: item.cat_id,
      dataSet: dataSet
    })
    // this.loadStockTransactionRecord(item)
  }

  onStockProductTransactionCloseClick() { 
    this.setState({ showStockProductTransactionPopup: false, itemnum: "", dataSet: [] })
  }

  onStockEditProductOpenClick() {
    let {messages} = this.props
    let itemnum = this.state.itemnum
    let title = ""
    let formDisplay = ""
    let formDisplay2 = ""
    let formDisplayCost = ""
    
    if (itemnum) {
      title = messages['Edit Item']
      formDisplay = "block"
      formDisplay2 = "none"
    } else {
      title = messages['Add Item']
      formDisplay = "none"
      formDisplay2 = "block"
      this.setState({ cat_id: 0 })
    }

    if (this.props.tool === "tool" || this.props.tool === "officemate") {
      formDisplayCost = "none"
    } else {
      formDisplayCost = "block"
    }

    this.setState({ 
      showStockPopup: true,
      showStockProductTransactionPopup: false,
      stockProductTitle: title,
      formDisplay: formDisplay, 
      formDisplay2: formDisplay2,
      formDisplayCost: formDisplayCost,
      productImages:[]
    })

    if(itemnum>0){
      let that = this
      StockStore.loadImages(this.props.tool,itemnum,function(result){
        that.setState({productImages:result.data.files})
      })
    }
  }

  onStockEditProductCloseClick() { 
    this.setState({ showStockPopup: false, showStockProductTransactionPopup: false, itemnum: "", dataSet: [], formValid: "", validState: "" })
  }

  onStockProductFormHideClick() {
    this.setState({ formDisplay: "none" })
  }

  onStockProductFormShowClick() {
    this.setState({ formDisplay: "block" })
  }

  onStockEditProductCategoryChange(e) { 
    let dataSet = this.state.dataSet
    dataSet['cat_id'] = e
    this.setState({ cat_id: e, dataSet: dataSet })
  }

  onTextStockEditProductChange(e) {
    let dataSet = this.state.dataSet
    dataSet[e.key] = e.value
    this.setState({ dataSet: dataSet, formValid: "", validState: "" })
  } 

  onImageUpload(){
    let {itemnum} = this.state
    if(itemnum>0){
      let that = this
      StockStore.loadImages(this.props.tool,itemnum,function(result){
        that.setState({productImages:result.data.files})
      })
    }
  }

  onNewCategory(){

  }

  onUpdateData(e){
    this.loadOutOfStockList(this.state.activePage)
  }

  onClearAfterSave() {
    this.setState({itemnum: "",dataSet:[]})
  }

  onReloadAfterSave(description) {
    
  }

  getRowStyle(item, index) {
    if (item.quantity === 0) {
      return 'stock-red-row'
    } else if (item.quantity <= 3) {
      return 'stock-orange-row'
    } else if (item.quantity > 3) {
      return ''
    }
  }

  renderTable() {
    let {messages} = this.props
    if (this.props.tool === "tool" || this.props.tool === "officemate") {
      return(
        <div className='display-overflow'>
          <table className="table table-responsive table-hover table-bordered-solid">
            <thead>
              <tr>
                <th>{messages['Product Code']}</th>
                <th className="col-md-4">{messages['Part Name']}</th>
                <th className="text-center">{messages['Quantity']}</th>
                <th className="text-center">{messages['Unit']}</th>
                <th className="text-center">{messages['Type']}</th>
                <th className="text-center">{messages['Shelf']}</th>
                <th className="col-md-3">{messages['Note']}</th>
              </tr>
            </thead>
            <tbody>
              { this.renderRowData() }    
            </tbody>
          </table>
        </div>  
      )
    } else {
      return(
        <div className='display-overflow'>
          <table className="table table-responsive table-hover table-bordered-solid">
            <thead>
              <tr>
                <th>{messages['Product Code']}</th>
                <th className="col-md-6">{messages['Part Name']}</th>
                <th className="text-center">{messages['Quantity']}</th>
                <th className="text-center">{messages['Unit']}</th>
                <th className="text-center">{messages['Type']}</th>
                <th>{messages['Cost']}</th>
                <th>{messages['Price']}</th>
                <th className="text-center">{messages['Shelf']}</th>
                <th >{messages['Note']}</th>
              </tr>
            </thead>
            <tbody>
              { this.renderRowData() }   
            </tbody>
          </table>
        </div>  
      )  
    }  
  }

  getDecimal(number) {
    if (isNaN(number)) {
      return 0
    } else if (number==="") { 
      return ""
    } else {
      return parseFloat(number).toFixed(2) * 1
    }
  }

  renderRowData() {
    // if (this.props.tool == "tool" || this.props.tool == "officemate") {
    //   var col = 6
    // } else {
    //   var col = 7
    // }
    let col = 7

    if (this.props.data.length === 0) {
      return(<tr><td colSpan={col}>{this.props.messages['No Data']}</td></tr>)
    } else {
      if (this.props.tool === "tool" || this.props.tool === "officemate") {
        return(
          this.props.data.map((item, index) =>
            <tr key={index} className={this.getRowStyle(item, index)}>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.productcode }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.description }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ this.getDecimal(item.quantity) }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.unit }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.cat_name }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.location }</td>  
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.remark }</td>    
            </tr> 
          )
        )
      } else {
        return(
          this.props.data.map((item, index) =>
            <tr key={index} className={this.getRowStyle(item, index)}>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.productcode }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.description }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ this.getDecimal(item.quantity) }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.unit }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.cat_name }</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-right">{item.cost_per_unit}</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-right">{item.price_per_unit}</td>
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) } className="text-center">{ item.location }</td>  
              <td onClick={ this.onStockProductTransactionOpenClick.bind(this, item) }>{ item.remark }</td>  
            </tr> 
          )
        )
      }  
    }
  }

  // renderStockEditProductPopup() {
  //   return(      
  //       <StockEditProductModal        
  //       show={this.state.showStockEditProductPopup}
  //       onHide={this.onStockEditProductCloseClick.bind(this)}
  //       tool={this.props.tool}
  //       images={this.state.productImages}
  //       onCatChange={this.onStockEditProductCategoryChange.bind(this)}
  //       onTextChange={this.onTextStockEditProductChange.bind(this)}
  //       onImageUpload={this.onImageUpload.bind(this)}
  //       onNewCategory={this.onNewCategory.bind(this)}
  //       dataSet={this.state.dataSet}
  //       updateData={this.onUpdateData.bind(this)}
  //       clearAfterSave={this.onClearAfterSave.bind(this)}
  //     >
  //       </StockEditProductModal>
       
  //   )
  // }

  renderStockEditProductModal(mode) {
    return(
          <StockEditProductModal
            mode={mode}
            ref='editProduct'
            show={this.state.showStockPopup}
            onHide={this.onStockEditProductCloseClick.bind(this)}
            tool={this.props.tool}
            searchType={this.props.searchType}
            images={this.state.productImages}
            onCatChange={this.onStockEditProductCategoryChange.bind(this)}
            onTextChange={this.onTextStockEditProductChange.bind(this)}
            onImageUpload={this.onImageUpload.bind(this)}
            onNewCategory={this.onNewCategory.bind(this)}
            dataSet={this.state.dataSet}
            updateData={this.onUpdateData.bind(this)}
            clearAfterSave={this.onClearAfterSave.bind(this)}
            onReloadAfterSave={this.onReloadAfterSave.bind(this)}
          >
          </StockEditProductModal>
    )
  }

  onRowWorkClick(item,items) {
    this.onStockProductTransactionOpenClick(items)
  }

  renderMobileTable() {
    let {data} = this.props
    let fieldMap = {title:'description',amount:'_amount',sub_title:'productcode',date:'name',status:'',sub_status:''}
    let _data = []
    _data = data.map((item,index)=>{
      let _item = item
      _item = Object.assign({_amount:item.quantity+' '+item.unit}, _item)
      return _item
    })
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'itemnum'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render(){
    let {isMobile,messages} = this.props
    return (
      <div>
        <Row>
          <Col md={12}>
            <Box loading={this.props.loading}>
              <Box.Header border={false}>
                <Box.Title>
                  {messages['Out Of Stock Item']}     
                </Box.Title>
              </Box.Header>
              <Box.Body>  
                {isMobile?this.renderMobileTable():this.renderTable()}
                <div className="text-right">
                  <Pagination
                    prev={messages['Previous']}
                    next={messages['Next']}
                    first={false}
                    last={false}
                    ellipsis
                    boundaryLinks
                    items={ this.props.totalPage }
                    maxButtons={5}
                    activePage={this.state.activePage}
                    onSelect={this.handleSelect.bind(this)}
                  />
                </div>
              </Box.Body>
            </Box>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div>
              <StockProductTransactionModal
                show={this.state.showStockProductTransactionPopup}
                onHide={this.onStockProductTransactionCloseClick.bind(this)}
                onEdit={this.onStockEditProductOpenClick.bind(this)}
                description={this.state.description}
                added_date={this.state.added_date}
                added_by={this.state.added_by}
                role={this.props.role}            
                quantity={this.state.quantity}
                unit={this.state.unit}
                itemnum={this.state.itemnum}            
                stockType={this.props.tool}
                transaction_record={this.state.transaction_record}
                onShowSerialNumber={()=>{}}
                itemData={this.state.dataSet}
                renderInfoTable={this.renderStockEditProductModal.bind(this)} 
              >
              </StockProductTransactionModal>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {/* {this.renderStockEditProductPopup()} */}
            {this.renderStockEditProductModal('modal')}
          </Col>
        </Row>
      </div>
    )
  }
}

StockOutOfStockReport.defaultProps = {
  show : false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockOutOfStockReport}),null,null,{withRef:true},
)(StockOutOfStockReport);





// WEBPACK FOOTER //
// ./src/view/stock/StockOutOfStockReport.js